import axios from 'axios';
import env from 'config';
import { RefreshTokenService } from 'services/_refresh-token.service';

export { DEFAULT_HEADERS } from 'services/_http-headers';

export const httpClient = axios.create({
  baseURL: env.server_url,
  withCredentials: true,
});

export const refreshTokenHandler = new RefreshTokenService(httpClient);
refreshTokenHandler.attachInterceptors();
